// extracted by mini-css-extract-plugin
export default {"confirmationContainer":"JVx46R9NfciM9Y4fHhDz","confirmationCard":"Ayyw7hSJ0g2pf4Fz15iq","message":"ncRm6L6bOahRmQtUK5Ae","subMessage":"l6Su4eTi2TcyNh6Lcqqw"};